"use client";

import type { Metadata } from "next";
import { Reem_Kufi, Amiri, Open_Sans } from "next/font/google";
import { useState } from "react";
import "./globals.css";
import NavigationMenu from "@/features/navigation/NavigationMenu";
import { TourFormModal } from "@/features/modal/TourFormModal";
import { ModalProvider } from "@/context/ModalContext";

const reemKufi = Reem_Kufi({
  subsets: ["latin", "arabic"],
  variable: "--font-reem-kufi",
  weight: "variable",
});

const amiri = Amiri({
  subsets: ["latin", "arabic"],
  variable: "--font-amiri",
  weight: ["400", "700"],
});

const openSans = Open_Sans({
  subsets: ["latin"],
  variable: "--font-open-sans",
  weight: ["300", "400", "500", "600", "700"],
});

const TOUR_REGISTRATION_FORM_URL =
  "https://docs.google.com/forms/d/e/1FAIpQLSc0NUMtaoW1vjNEyWWujPuQbNiPFHSwY_JZ1o5G3gNPVktDFw/viewform?embedded=true";

export default function RootLayout({
  children,
}: Readonly<{
  children: React.ReactNode;
}>) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  return (
    <html
      lang="en"
      className={`${reemKufi.variable} ${amiri.variable} ${openSans.variable}`}
    >
      <head>
        <meta name="viewport" content="initial-scale=1, width=device-width" />
      </head>
      <body className="h-full w-full bg-stone-950">
        <ModalProvider onOpenModal={handleOpenModal}>
          <header className="fixed top-0 left-0 right-0 z-10">
            <NavigationMenu />
          </header>
          <main>{children}</main>
        </ModalProvider>
        <TourFormModal
          isOpen={isModalOpen}
          onClose={handleCloseModal}
          googleFormUrl={TOUR_REGISTRATION_FORM_URL}
        />
      </body>
    </html>
  );
}
